<template>
  <v-menu offset-y left>
    <template v-slot:activator="{ on }">
      <v-btn icon class="px-0" color="black" v-on="on" >
        <v-icon small>fa-user</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item>
        <v-list-item-title>{{ nombreOperador }}</v-list-item-title>
      </v-list-item>
      <v-divider></v-divider>
      <fh-acceso-anterior isMenu/>
      <v-list-item :href="configurationUrl" target="_blank">
        <v-list-item-action>
          <v-icon>fa-user-cog</v-icon>
        </v-list-item-action>
        <v-list-item-title>Configuraciones</v-list-item-title>
      </v-list-item>
      <v-list-item @click="handleLogout">
        <v-list-item-action>
          <v-icon>fa-power-off</v-icon>
        </v-list-item-action>
        <v-list-item-title>Cerrar Sesión</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  import FhAccesoAnterior from '@/components/app/FhAccesoAnterior'
  import SessionService from '@/services/SessionService'
  import {CONFIGURATION_URL, LOGOUT_URL, SITE_NAME} from '@/config'
  import {mapActions} from 'vuex'

  export default {
    name: 'FhMenuOperador',
    components: {FhAccesoAnterior},
    computed: {
      nombreOperador() {
        return SessionService.getNombreOperador()
      },
      configurationUrl() {
        return CONFIGURATION_URL
      }
    },
    methods: {
      ...mapActions('session', [
        'logout'
      ]),
      handleLogout() {
        this.logout()
        location.href = `${LOGOUT_URL}?nombre=${SITE_NAME}&redirect=${location.origin}`
      }
    }
  }
</script>

<style scoped>

</style>
